export default __webpack_public_path__ + "static/media/ic_check-circle_3.fe36d2b5.svg";